// ExploreDoctors.jsx
import React, { useState } from "react";
import DoctorRail from "../components/patient/Home/DoctorRail";
import { useNavigate } from "react-router-dom";
import { Search, ArrowLeft, MapPin } from "lucide-react";
import "./ExploreDoctors.css";

export default function ExploreDoctors({ onDoctorClick, onOpenMap }) {
const [searchQuery, setSearchQuery] = useState("");
const [keywordCounts, setKeywordCounts] = useState([]);

  const navigate = useNavigate();
 const handleOpenDoctorProfile = React.useCallback(
    (doctorId) => {
      if (!doctorId) return;
      // adjust the route if your doctor profile path is different
      navigate(`/doctor/${doctorId}`);
    },
    [navigate]
  );

  return (
    <div className="explore-page">
      {/* Header */}
      <div className="explore-header">
        <button className="back-btn" onClick={() => window.history.back()}>
          <ArrowLeft />
        </button>

        <div className="search-wrapper">
          <Search className="search-icon" />
          <input
            className="search-input"
            placeholder="Kërko mjek, klinikë ose simptome"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>

        <button className="map-btn" onClick={onOpenMap}>
          <MapPin className="map-icon" />
        </button>
      </div>

      {/* Embedded doctor rail */}
      <div className="explore-rail-container">
       <DoctorRail
  onDoctorClick={handleOpenDoctorProfile}
  max={999}
  showControls={true}
  searchQuery={searchQuery}
  externalSearch={searchQuery}
  onKeywordPool={setKeywordCounts}
/>
      </div>
    </div>
  );
}
